
import Vue from "vue";
import { Component, PropSync, Prop } from "vue-property-decorator";
import { isEmailValid } from "@/utils/validation";

@Component
export default class EmailAndPasswordForm extends Vue {
  // 📦 Email that the user enters
  @PropSync("userEmail")
  private email!: string | null;

  // 📦 Password that the user enters
  @PropSync("userPassword")
  private password!: string | null;

  // 🔃 Flag responsible for showing loading indicator
  @Prop()
  private isLoading: boolean = false;

  // 👮‍♂️ Email validation rules
  private emailRules = [
    (v: string) =>
      (!!v && isEmailValid(v)) || "Please provide a valid email address",
  ];

  // 🚩 Flag responsible for revealing the user's password
  private passwordVisible = false;

  // 🚩 Flag for whether the provided email is valid
  private get isProvidedInformationValid(): boolean {
    return this.email != null && this.email !== "";
  }

  // 🚩 Flag for whether the sign up flow is "request access" only
  private get isSignUpRequestAccess(): boolean {
    return process.env.VUE_APP_SIGN_UP_FLOW === "REQUEST_ACCESS";
  }
}
